import { useState, ChangeEvent, useEffect } from 'react'

export function useFormFields<T>(
  initialState: T,
): [T, (event: ChangeEvent<HTMLInputElement>) => void] {
  const [fields, setValues] = useState<T>(initialState)
  useEffect(() => {
    // Allow to override initial state if the previous object was empty
    if (Object.keys(fields).length === 0) {
      setValues(initialState)
    }
  }, [fields, initialState])

  return [
    fields,
    function (event: ChangeEvent<HTMLInputElement>) {
      const { name, value, type, checked } = event.target
      setValues({
        ...fields,
        [name]: type === 'checkbox' ? checked : value,
      })
    },
  ]
}
